import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AtendimentoApiService {
   private URL = environment.angularJSconstants.URL_API_ATENDIMENTO;

  constructor(private http: HttpClient) {}

  atualizarAtendimento(objeto) {

    const token = localStorage.getItem('ls.token').replace(/"/g, '');

    if (token) {
      const headers = new HttpHeaders({
        'Authorization': token,
      });

      return this.http.post(`${this.URL}/atendimentos`, objeto, {
        headers,
        observe: "response",
        responseType: "arraybuffer"
      }
      );
    }

  }

  criarTicket(objeto) {
    const token = localStorage.getItem('ls.token').replace(/"/g, '');

    if (token) {
      const headers = new HttpHeaders({
        'Authorization': token,
      });

      return this.http.post(`${this.URL}/atendimentos`, objeto, {
        headers,
        observe: "response",
        responseType: "arraybuffer"
      }
      );
    }
  }
}
